import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FaviconService {
  private readonly faviconId = 'app-favicon';

  constructor() {
    // Create a favicon link element if one doesn't exist
    if (!this.getFaviconElement()) {
      this.createFaviconElement();
    }
  }

  /**
   * Set the favicon URL
   * @param url The URL to the favicon image
   */
  setFavicon(url: string): void {
    const faviconElement = this.getFaviconElement() || this.createFaviconElement();
    faviconElement.href = url;
  }

  private getFaviconElement(): HTMLLinkElement | null {
    return document.getElementById(this.faviconId) as HTMLLinkElement;
  }

  private createFaviconElement(): HTMLLinkElement {
    const link = document.createElement('link');
    link.id = this.faviconId;
    link.rel = 'icon';
    link.type = 'image/x-icon';
    document.head.appendChild(link);
    return link;
  }
}
